<script>
    import CRUD from './CRUD.svelte';
    import { onMount } from 'svelte';
    import { t } from 'svelte-i18n';
    import { 
        fetchCategorias, 
        saveCategoria, 
        removeCategoria, 
        searchCategorias, 
        subscribeToCategorias, 
        unsubscribeFromCategorias,
        getCategoriasForDropdown
    } from '../controllers/categoriaController.js';

    // Configuración de las columnas para la tabla de categorías
    let categoriaColumns = [
        { label: $t('categories.description'), field: 'descrip', type: 'text' },
        { label: $t('categories.parentCategory'), field: 'parent', type: 'relation', relationField: 'descrip' }
    ];

    // Estructura del nuevo objeto Categoría
    let newCategoria = {
        descrip: '',
        parent: null // Relación con categoría padre para jerarquías
    };

    // Configuración de los campos para la edición de categorías
    let editColumns = [
        { label: $t('categories.description'), key: 'descrip', type: 'text', required: true },
        { label: $t('categories.parentCategory'), key: 'parent', type: 'select', required: false, fetchOptions: { key: 'id', value: 'descrip' }, options: [] }
    ];

    // Función para cargar y transformar categorías padre
    let parentOptions = [];

    async function loadParentCategorias() {
        try {
            const fetchedCategorias = await getCategoriasForDropdown();

            if (Array.isArray(fetchedCategorias)) {
                parentOptions = fetchedCategorias.map(e => ({
                    key: e[editColumns.find(col => col.key === 'parent').fetchOptions.key],
                    value: e[editColumns.find(col => col.key === 'parent').fetchOptions.value],
                }));

                // Asigna las opciones transformadas a las columnas editables
                editColumns.find(column => column.key === 'parent').options = parentOptions;
            } else {
                console.error('Se esperaba un array de categorías, pero se obtuvo:', fetchedCategorias);
            }
        } catch (error) {
            console.error('Error al cargar las categorías padre:', error);
        }
    }

    // Cargar las categorías padre al montar el componente
    onMount(() => {
        loadParentCategorias();
    });
</script>

<CRUD 
    title={$t('categories.title')}
    entityName="categoria"
    newEntity={newCategoria}
    columns={categoriaColumns}
    fetchEntities={fetchCategorias}
    saveEntity={saveCategoria}
    removeEntity={removeCategoria}
    searchEntities={searchCategorias}
    subscribeToChanges={subscribeToCategorias}
    unsubscribeFromChanges={unsubscribeFromCategorias}
    editColumns={editColumns}
/>
